define("tmds/layers/utils", [
    "jquery",
    "tmds/geometry/Extent",
    "tmds/geometry/Line",
    "tmds/geometry/Point",
    "tmds/geometry/Polyline",
    "tmds/renderers/UniqueValueRenderer",
    "tmds/utils/symbolUtils",
    "tmds/validator"
], function($, Extent, Line, Point, Polyline, UniqueValueRenderer, symUtils, validator) {
	"use strict";

    
	/**
	 * create geometry based on the data metadata and attributes
	 * @param entity {Object} data attributes in field-value hashmap
	 * @param metadata {Object} see the metadata parameter description of tmds.layers.Layer constructor
	 * @return {tmds.geometry.Geometry}
	 */
    function getGeometry(entity, metadata) {
        var geom = null;

        if (! validator.isDataObject(metadata) || 
        	! validator.isString(metadata.geometryType) || 
        	! validator.isDataObject(metadata.geometryInfo) || 
        	! validator.isDataObject(entity)) {
            throw new Error("tmds/layers/utils::getGeometry: metadata and/or entity are invalid.");
        }

        switch (metadata.geometryType) {
            case "Point":
                geom = new Point({
                    x: entity[metadata.geometryInfo.x],
                    y: entity[metadata.geometryInfo.y]
                });

                break;

            case "Line":
                geom = new Line({
                    x1: entity[metadata.geometryInfo.x1],
                    y1: entity[metadata.geometryInfo.y1],
                    x2: entity[metadata.geometryInfo.x2],
                    y2: entity[metadata.geometryInfo.y2]
                });

                break;

            case "Polyline":
                geom = new Polyline({
                    paths: entity[metadata.geometryInfo.paths]
                });

                break;

            case "Extent":
                geom = new Extent({
                    xmin: entity[metadata.geometryInfo.xmin],
                    ymin: entity[metadata.geometryInfo.ymin],
                    xmax: entity[metadata.geometryInfo.xmax],
                    ymax: entity[metadata.geometryInfo.ymax]
                });

                break;
            default:
                break;
        }
        
        if(geom == null)
			throw new Error("tmds/layers/utils::getGeometry: metadata and/or entity are invalid.");

        return geom;
    }

    /**
     * create a default symbol based on the inputs
     * @param entity {Object} data attributes in field-value hashmap
     * @param metadata {Object} see the metadata parameter description of tmds.layers.Layer constructor
     * @param renderer {Renderer | Object} layer renderer as Renderer instance or in JSON representation
     * @return {tmds.symbols.Symbol}
     */
    function getSymbol(entity, metadata, renderer) {
        if (!metadata || !metadata.geometryType || !entity) {
        	throw new Error("tmds/layers/utils::getSymbol: metadata and/or entity are missing.");
        }

        var symbol, fldValue, uvr;
        var geometryType = metadata && metadata.geometryType;
        var rendererType = renderer ? renderer.type : null;

        switch (rendererType) {
            case "SimpleRenderer":
                symbol = symUtils.fromJson(renderer.symbol);

                break;

            case "UniqueValueRenderer":
                fldValue = entity[renderer.fieldName];
                
                if (renderer.fieldName1) {
                	fldValue += renderer.fieldDelimeter + entity[renderer.fieldName1];

                    if (renderer.fieldName2) {
                        fldValue += renderer.fieldDelimeter + entity[renderer.fieldName2];
                    }
                }
                
                uvr = (renderer instanceof UniqueValueRenderer) ? renderer : new UniqueValueRenderer(renderer);
                symbol = uvr && uvr.getSymbol(fldValue);

                break;

            default:
                break;
        }

        return symbol || symUtils.fromSpatialType(geometryType);
    }
    
    var utils = {
    	'getGeometry' : getGeometry,
    	'getSymbol' : getSymbol
    };

    return utils;
});